export const setApplicationSent = (applicationSent) => ({
  type:"SET_APPLICATION_SENT",
  applicationSent
});

export const setVerificationQuestions = (payload) => ({
  type:"SET_VERIFICATION_QUESTIONS",
  verificationQuestions: payload  
});

export const setVerificationSent = (verificationSent) => ({
  type:"SET_VERIFICATION_SENT",
  verificationSent
});

export const setApplicationComplete = (applicationComplete) => ({
  type:"SET_APPLICATION_COMPLETE",
  applicationComplete
});

export const setCurrentLocation = (currentLocation) => ({
  type:"SET_CURRENT_LOCATION",
  currentLocation
});

export const setApplicationId = (visaApplicationId) => ({
  type:"SET_APPLICATION_ID",
  visaApplicationId
});

export const setIsMember = (isMember) => ({
  type:"SET_IS_MEMBER",
  isMember
});

export const setAuthUserSelected = () => ({
  type:"SET_AUTH_USER_SELECTED",  
});

export const setBpiSelected = () => ({
  type:"SET_BPI_SELECTED",  
});

export const setApplicationAuthUsers = (authUsersNum) => ({
  type:"SET_NUM_AUTH_USERS",  
  authUsersNum
});

export const clearState = () => ({
  type:"CLEAR_STATE"
});

export const setBpi = (bpi) => ({
  type:"SET_BPI",
  bpi
});



// WEBPACK FOOTER //
// ./src/actions/applicationAction.js